import type { SxProps } from "@mui/material"

import { CHECKBOX_BORDER_COLOR } from "@constants/colors"

const checkboxBorder: SxProps = {
  color: CHECKBOX_BORDER_COLOR
}

export default {
  checkboxBorder
}
